import { useState, useEffect } from 'react';
import styles from './App.module.css';
import SearchBar from './SearchBar';
import SearchResults from './SearchResults';
import Playlist from './Playlist';
import Spotify from '../API/Spotify';

function App() {
    // State of the search results
  const [searchResults, setSearchResults] = useState([]);
  // State of the Playlist
  const [playlistTracks, setPlaylistTracks] = useState([]);

  useEffect(() => {
    // Retrieve the search term from local storage
    const searchTerm = localStorage.getItem('searchTerm');
  
    if (searchTerm) {
      // Perform the search
      search(searchTerm);
  
      // Clear the search term from local storage
      localStorage.removeItem('searchTerm');
    }
  }, []);

  // Add a track to the playlist
  const addTrack = (track) => {
    // Check for duplicates in the playlist.
    if (!playlistTracks.some(playlistTrack => playlistTrack.uri === track.uri)) {
      setPlaylistTracks([...playlistTracks, track]);
    }
  
    console.log(track);
  }

  // Remove a track from the playlist
  const removeTrack = (track) => {
    setPlaylistTracks(playlistTracks.filter((playlistTrack) => playlistTrack.uri !== track.uri));
  }

  const search = (term) => {
    // Store the search term in local storage
    localStorage.setItem('searchTerm', term);
  
    Spotify.search(term).then(result => setSearchResults(result));
  };

  const getURIs = () => {
    // Return an array of URIs from the playlistTracks
    return playlistTracks.map(track => track.uri);
  }

  const savePlaylist = (name, uris) => {
    // Save the playlist to Spotify
    Spotify.savePlaylist(name, uris);
  }

  const resetPlaylist = () => {
    setPlaylistTracks([]);
  }

  return (
    <div className={styles.App} >
      <div className={styles.top}>
        <h1>Time to get Ja<i>mmm</i>ing</h1>
        <SearchBar onSearch={search}/>
      </div>      
      <div className={styles.Lists}>
        <SearchResults tracks={searchResults} onAdd={addTrack} />
        <Playlist tracks={playlistTracks} onRemove={removeTrack} getURIs={getURIs} savePlaylist={savePlaylist} resetPlaylist={resetPlaylist} />   
      </div>
      <p>Created by <a href="https://github.com/EvelynSays" target="_blank" rel='noreferrer'>EvelynSays</a></p>
    </div>
  );
}

export default App;
